var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 32 32",
    viewBox: "0 0 32 32",
    id: "Linkedin",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M4.983,8.375H4.94c-2.087,0-3.44-1.367-3.44-3.101c0-1.767,1.393-3.106,3.523-3.106 c2.127,0,3.436,1.335,3.477,3.101C8.5,7.002,7.15,8.375,4.983,8.375z",
    className: "colorffffff svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffab80",
    d: "M8.5,5.27C8.475,4.184,7.967,3.264,7.087,2.714C6.903,2.692,6.721,2.669,6.523,2.669 C4.393,2.669,3,4.008,3,5.775c0,1.072,0.52,2.001,1.408,2.556C4.582,8.352,4.755,8.375,4.94,8.375h0.043 C7.15,8.375,8.5,7.002,8.5,5.27z",
    className: "color80d8ff svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff894c",
    d: "M4.983,8.875H4.94C2.657,8.875,1,7.361,1,5.275c0-2.089,1.692-3.606,4.023-3.606 c2.292,0,3.928,1.476,3.977,3.589C9,7.359,7.311,8.875,4.983,8.875z M5.023,2.669C3.243,2.669,2,3.741,2,5.275 c0,1.531,1.209,2.601,2.94,2.601h0.043C6.76,7.875,8,6.804,8,5.27C7.963,3.694,6.795,2.669,5.023,2.669z",
    className: "color455a64 svgShape"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 18,
    x: 2.5,
    y: 10.5,
    fill: "#ffffff",
    className: "colorffffff svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffab80",
    d: "M7.5,28.5H4V12c0-0.552,0.447-1,1-1h2.5V28.5z",
    className: "color80d8ff svgShape"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff894c",
    d: "M7.5,29h-5C2.224,29,2,28.776,2,28.5v-18C2,10.224,2.224,10,2.5,10h5C7.776,10,8,10.224,8,10.5v18 C8,28.776,7.776,29,7.5,29z M3,28h4V11H3V28z",
    className: "color455a64 svgShape"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M23.5,10.5c-2.457,0-4.632,1.188-6,3.014V10.5h-6v18H16h1.5V19c0-1.933,1.567-3.5,3.5-3.5 s3.5,1.567,3.5,3.5v9.5h6v-11C30.5,13.634,27.366,10.5,23.5,10.5z",
    className: "colorffffff svgShape"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffab80",
    d: "M23.724,12.005c-1.884,0.069-3.586,0.835-4.866,2.046C18.532,14.359,18,14.151,18,13.703v-0.784 c-0.176,0.19-0.345,0.387-0.5,0.595V11H14c-0.553,0-1,0.448-1,1v16.5h3h1.5V19c0-1.933,1.567-3.5,3.5-3.5 c1.077,0,2.029,0.498,2.672,1.264C24.479,17.405,25,18.389,25,19.5v9h5.5v-11c0-0.372-0.037-0.734-0.094-1.09 C29.288,13.783,26.708,11.896,23.724,12.005z",
    className: "color80d8ff svgShape"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff894c",
    d: "M30.5,29h-6c-0.276,0-0.5-0.224-0.5-0.5V19c0-1.654-1.346-3-3-3s-3,1.346-3,3v9.5 c0,0.276-0.224,0.5-0.5,0.5h-6c-0.276,0-0.5-0.224-0.5-0.5v-18c0-0.276,0.224-0.5,0.5-0.5h6c0.276,0,0.5,0.224,0.5,0.5v3.014 c0,0.276-0.224,0.5-0.5,0.5s-0.5-0.224-0.5-0.5V11h-5v17h5v-9c0-2.206,1.794-4,4-4s4,1.794,4,4v9h5V17.5c0-3.584-2.916-6.5-6.5-6.5 c-1.384,0-2.722,0.406-3.871,1.173c-0.229,0.152-0.54,0.092-0.693-0.138s-0.092-0.54,0.139-0.693C20.388,10.464,21.918,10,23.5,10 c4.136,0,7.5,3.364,7.5,7.5v11C31,28.776,30.776,29,30.5,29z",
    className: "color455a64 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.845682744293d7f633efbb0a3188d73e.svg";
export { ForwardRef as ReactComponent };